// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NumericAndMoneyFormatConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';

export default {
  FORMATS_NOT_AVAILABLE_FOR_RUNNING_FIELD: [
    '% of Group',
    '% of Group (with rounding)',
    '% of Subtotal',
    '% of Subtotal (with rounding)',
    '% of Grandtotal',
    '% of Grandtotal (with rounding)',
    '% of Sidetotal',
    '% of Sidetotal (with rounding)'
  ],
  FORMAT_NOT_AVAILABLE_ON_FIELD_CAN_NOT_SET_SUBTOTAL: [
    '% of Subtotal',
    '% of Subtotal (with rounding)'
  ],
  FORMATS_NOT_AVAILABLE_FOR_PART_TYPES: {
    partType: [REPORT_PART_TYPE.Chart, REPORT_PART_TYPE.Gauge, REPORT_PART_TYPE.Map],
    formats: [
      '% of Subtotal',
      '% of Subtotal (with rounding)',
      '% of Grandtotal',
      '% of Grandtotal (with rounding)',
      '% of Sidetotal',
      '% of Sidetotal (with rounding)'
    ]
  },
  FORMATS_ONLY_ON_PIVOT_GRID_VALUE_CONTAINER: ['% of Sidetotal', '% of Sidetotal (with rounding)']
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.NumericAndMoneyFormatConstants.js